import './app.scss';
import domready from 'domready';
import 'lazysizes';
import { loadLazyImages } from './utilities/js/lazy-image-loader';
import { EventScroller } from './utilities/js/event-scroller';
import { MediaMatchHandler } from './utilities/js/media-match-handler';
import Siteheader from './layout/siteheader/siteheader';
import SiteFooter from './layout/sitefooter/sitefooter';

// GLOBAL OPTIONS
window.OPTIONS = { // eslint-disable-line
    breakpoints: {
        s: 320,
        m: 768,
        l: 1024,
        xl: 1280,
        xxl: 1440,
        xxxl: 1920
    },
    loader: '<span class="loading" data-loader><span class="loading__loader"><i>loading...</i></span></span>'
};

window.eventScroller = new EventScroller();
window.mediaMatch = new MediaMatchHandler();

window.youtubeApi = false;
window.youtubeApiLoading = false;

const checkInview = () => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('inview');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1 });

    const $inviews = document.querySelectorAll('[data-inview]:not(.inview)');
    $inviews.forEach((target) => {
        observer.observe(target);
    });
};

const initDataForCheckboxes = ($content) => {
    const $$checkboxTrigger = $content.querySelectorAll('[data-for-checkbox]');

    const resetAllTriggersByReference = (reference, state) => {
        const $allReferenceCheckboxes = $content.querySelectorAll(`[data-for-checkbox="${reference}"]`);
        const $checkbox = $content.querySelector(`#${reference}`);

        if ($checkbox) {
            $checkbox.checked = false;
        }

        if ($allReferenceCheckboxes.length > 0) {
            $allReferenceCheckboxes.forEach($checkboxTrigger => {
                let triggerActiveAttribute = 'aria-pressed';

                if ($checkboxTrigger.dataset.activeAttribute !== undefined) {
                    triggerActiveAttribute = $checkboxTrigger.dataset.activeAttribute;
                }

                $checkboxTrigger.setAttribute(triggerActiveAttribute, state);
            });
        }
    };

    // reset checkboxes and triggers by event
    window.addEventListener('checkbox.trigger.reset', (e) => {
        resetAllTriggersByReference(e.detail.referenceId, e.detail.state);
    });

    if ($$checkboxTrigger.length > 0) {
        $$checkboxTrigger.forEach($checkboxTrigger => {
            const checkboxReference = $checkboxTrigger.dataset.forCheckbox;
            let triggerActiveAttribute = 'aria-pressed';

            if ($checkboxTrigger.dataset.activeAttribute !== undefined) {
                triggerActiveAttribute = $checkboxTrigger.dataset.activeAttribute;
            }

            const $checkbox = $content.querySelector(`#${checkboxReference}`);

            $checkboxTrigger.onclick = () => {
                // trigger event before checkbox state is changed
                window.dispatchEvent(new CustomEvent('checkbox.trigger.click', {
                    view: window,
                    bubbles: true,
                    cancelable: false,
                    detail: {
                        trigger: $checkboxTrigger,
                        checkbox: $checkbox,
                        state: $checkbox.checked
                    }
                }));

                if ($checkbox.checked === true) {
                    resetAllTriggersByReference(checkboxReference, false);
                } else {
                    $checkbox.checked = true;
                    $checkboxTrigger.setAttribute(triggerActiveAttribute, $checkbox.checked);
                }

                // trigger event after checkbox state is changed
                window.dispatchEvent(new CustomEvent('checkbox.trigger.active', {
                    view: window,
                    bubbles: true,
                    cancelable: false,
                    detail: {
                        trigger: $checkboxTrigger,
                        checkbox: $checkbox,
                        state: $checkbox.checked
                    }
                }));
            };

            if ($checkbox) {
                $checkbox.onchange = () => {
                    $checkboxTrigger.setAttribute(triggerActiveAttribute, $checkbox.checked);
                };
            }
        });
    }
};

const initContent = ($content) => {
    console.log('start app');

    initDataForCheckboxes($content);
    loadLazyImages();

    window.addEventListener('content.loaded', (e) => {
        initDataForCheckboxes($content);
    });
};

domready(function () {
    const initApplication = () => {
        initContent(document);

        window.eventScroller.init();

        const $sitefooter = document.querySelector('[data-sitefooter="nav"]');

        if ($sitefooter) {
            const sitefooterAPI = new SiteFooter($sitefooter);
            $sitefooter.API = sitefooterAPI;
        }

        window.setTimeout(() => {
            checkInview();
            document.documentElement.style.scrollBehavior = 'smooth';
        }, 750);

        const $siteheader = document.querySelector('[data-siteheader="root"]');

        if ($siteheader) {
            const siteheaderAPI = new Siteheader($siteheader);
            siteheaderAPI.initialize();
        }

        document.body.classList.add('page--loaded');
        window.addEventListener('beforeunload', () => {
            const isMailTo = document.activeElement.protocol === 'mailto:';
            const isTel = document.activeElement.protocol === 'tel:';

            if (!(isMailTo && isTel)) {
                document.body.classList.remove('page--loaded');
            }
        });

        window.addEventListener('pageshow', (event) => {
            const historyTraversal = event.persisted || (typeof window.performance !== 'undefined' && window.performance.navigation.type === 2);
            if (historyTraversal) {
                window.location.reload();
            }
        });

        const contentUpdateEvent = new CustomEvent('content.loaded', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: document
            }
        });

        window.dispatchEvent(contentUpdateEvent);
    };

    initApplication();
});
